import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-text-svg-cellrender',
  templateUrl: './text-svg-cellrender.component.html',
  styleUrls: ['./text-svg-cellrender.component.scss']
})
export class TextSvgCellrenderComponent implements ICellRendererAngularComp {
  params;
  showIcon = true;
  constructor() {}
  ngOnInit(): void {}
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
     if (!params.value) {
      this.showIcon = false;
    }

}
refresh(params: ICellRendererParams<any, any>): boolean {
  this.params = params;
  this.showIcon = !!params.value;
  return false
}
}


